import axios from "axios";
import User from "./User";
import Config from "../utils/Config"

const authFetch = axios.create({
    baseURL: Config.baseURL,
});


authFetch.interceptors.request.use(function (config) {
    let token = User.getToken();
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

authFetch.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error == null || error.response == null || error.response.status == null || error.response.status === 401) {
        if (window.location.pathname !== process.env.PUBLIC_URL + "/login")
            window.location = process.env.PUBLIC_URL + "/login";
    } else if (error.response.status === 403 && error.response.data && error.response.data.code === 'ACCOUNT_SELECTION_REQUIRED') {
        // Benutzer mit User-Relationen muss erst ein Konto uebernehmen.
        if (window.location.pathname !== process.env.PUBLIC_URL + "/select-account")
            window.location = process.env.PUBLIC_URL + "/select-account";
        return new Promise(() => {});
    } else if (error.response.status === 403 && error.response.data && error.response.data.message === 'Kein Tenant zugewiesen.') {
        if (window.location.pathname !== process.env.PUBLIC_URL + "/no-tenant")
            window.location = process.env.PUBLIC_URL + "/no-tenant";
        // Return a never-resolving promise so the rejection doesn't propagate
        // and trigger the React error overlay while the redirect is in progress.
        return new Promise(() => {});
    } else if (error.response.status === 503) {
        // Wartungsmodus aktiv: Nicht-Admins auf die Wartungsseite umleiten.
        if (window.location.pathname !== process.env.PUBLIC_URL + "/maintenance")
            window.location = process.env.PUBLIC_URL + "/maintenance";
        return new Promise(() => {});
    }
    return Promise.reject(error);
});

export default authFetch;


// var appConfig = config;
//
//     return {
//     'request': function(config) {
//         if (config.reportRequest) {
//             config.headers.Authorization = 'Basic ' + appConfig.reportAuth;
//             return config;
//         }
//
//         var token = Benutzer.getToken();
//         if (token) {
//             config.headers.Authorization = 'JWT ' + token;
//         }
//         return config;
//     },
//     'responseError': function(rejection) {
//         if (rejection.status == 401) {
//             $state.go('login')
//         }
//         return $q.reject(rejection);
//     }
// }